export enum Role {
  // System admin role
  SYSTEM_ADMIN = 'SYSTEM_ADMIN',
  // Standard company user roles
  COMPANY_ADMIN = 'COMPANY_ADMIN',
  COMPANY_BASIC_USER = 'COMPANY_BASIC_USER',
  COMPANY_CCF_USER = 'COMPANY_CCF_USER',
  COMPANY_PCF_USER = 'COMPANY_PCF_USER',
  COMPANY_SBT_USER = 'COMPANY_SBT_USER',
  COMPANY_ESG_USER = 'COMPANY_ESG_USER',
  COMPANY_CSRD_USER = 'COMPANY_CSRD_USER',
  COMPANY_LKSG_USER = 'COMPANY_LKSG_USER',
  COMPANY_GLOBAL_REPORTING_ADMIN = 'COMPANY_GLOBAL_REPORTING_ADMIN',
  COMPANY_GLOBAL_REPORTING_USER = 'COMPANY_GLOBAL_REPORTING_USER',
  // Special user roles
  FREEMIUM_USER = 'FREEMIUM_USER',
  COMPANY_CSRD_AUDITOR = 'COMPANY_CSRD_AUDITOR'
}

export enum ProfileState {
  PROFILE_CREATED = "PROFILE_CREATED",
  PROFILE_COMPLETED = "PROFILE_COMPLETED",
  PROFILE_DEACTIVATED = "PROFILE_DEACTIVATED",
  INVITATION_EXPIRED = "INVITATION_EXPIRED",
}
